type Attrs = Record<string, string | ((event: Event) => void)>;

/** Tiny hyperscript helper — the whole UI framework. */
export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Attrs = {},
  ...children: (HTMLElement | string)[]
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  for (const [key, value] of Object.entries(attrs)) {
    if (typeof value === 'function') {
      node.addEventListener(key.replace(/^on/, ''), value);
    } else if (key === 'class') {
      node.className = value;
    } else {
      node.setAttribute(key, value);
    }
  }
  for (const child of children) {
    node.append(typeof child === 'string' ? document.createTextNode(child) : child);
  }
  return node;
}

export function formatMoney(cents: number): string {
  const dollars = Math.floor(Math.abs(cents) / 100);
  const sign = cents < 0 ? '-' : '';
  return `${sign}$${dollars.toLocaleString('en-US')}`;
}

/** Race times shown to hundredths — photo finishes live in the decimals. */
export function formatTime(seconds: number | null): string {
  if (seconds === null) return 'DNF';
  return `${seconds.toFixed(2)}s`;
}
